/* eslint-disable react-hooks/exhaustive-deps */
import { CustomModal, CustomTextArea } from "#components";
import useGet from "#hooks/useGet.js";
import ENDPOINTS from "#services/endPoints.js";
import QUERY_KEYS from "#services/queryKeys.js";
import { addProductInitialValues } from "#validations/initialValues.js";
import { addProductValidationSchema } from "#validations/validationSchema.js";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import ReactSelector from "../../../components/ReactSelector";

const CropAddProductModel = ({
  setOpen,
  open,
  handleAddCropProduct,
  productDetail,
  setProductDetail,
}) => {
  const [product, setProduct] = useState(null);
  const { data: productListData, isLoading: isProductLoading } = useGet(
    ENDPOINTS.ADD_PRODUCT,
    QUERY_KEYS.ADD_PRODUCT_QUERY_KEY
  );

  const productOptions = productListData?.data?.map((item) => ({
    id: item?._id,
    value: item?._id,
    label: item?.name,
  }));
  const getProductOptionById = (id) => {
    return productOptions?.find((option) => option.id === id);
  };

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    resetForm,
    setFieldValue,
    setValues,
    validateField,
  } = useFormik({
    initialValues: addProductInitialValues,
    validationSchema: addProductValidationSchema,
    onSubmit: async (values) => {
      handleAddCropProduct(values);
      setOpen({ ...open, add: false, edit: false });
      resetForm();
      setProduct(null);
      setProductDetail(null);
    },
  });


  const handleSelectProduct = (value) => {
    setProduct(value);
    setFieldValue("productName", value?.label);
    setFieldValue("productId", value?.id);
    setTimeout(() => {
      validateField("productName");
    });
  };

  const handleModalClose = () => {
    setOpen({ ...open, add: false, edit: false });
    resetForm();
    setProduct(null);
    setProductDetail(null);
  };

  const productData = productListData?.data?.find(
    (item) => item._id === product?.id
  );

  // useEffect(() => {
  //   if (productData && open.add) {
  //     setValues((prevValues) => ({
  //       ...prevValues,
  //       notes: productData.note || "",
  //       rate: productData.rate || "",
  //       containerSize: productData.containerSize || "",
  //       containerType: productData.containerType || "",
  //       containerUnit: productData.containerUnit || "L",

  //     }));
  //   }
  // }, [productData]);
  useEffect(() => {
    if (!productData) return;

    // If product is changed in Add or Edit mode
    if (open.add || open.edit) {
      setValues((prevValues) => ({
        ...prevValues,
        notes: productData.note || "",
        rate: productData.rate || "",
        rateUnit: productData.rateUnit || "",
        containerSize: productData.containerSize || "",
        containerType: productData.containerType || "",
        containerUnit: productData.containerUnit || "Ltr",
      }));
    }
  }, [productData, open.add, open.edit]);

  // console.log(productData,"productData");
  // useEffect(() => {
  //   if (open.edit) {
  //     setValues({
  //       productId: productDetail?.productId,
  //       notes: productDetail?.notes,
  //       productName: productDetail?.productName,
  //       rate: productDetail?.rate,
  //       containerSize: productDetail?.containerSize || "",
  //       containerType: productDetail?.containerType || "",
  //       containerUnit: productDetail?.containerUnit || "L",
  //     });
  //     setProduct(getProductOptionById(productDetail?.productId));
  //   }
  //   console.log(productDetail,"productDetail");

  // }, [productDetail]);
  useEffect(() => {
    if (!open.edit || !productDetail) return;

    setValues({
      productId: productDetail?.productId || "",
      notes: productDetail?.notes || "",
      productName: productDetail?.productName || "",
      rate: productDetail?.rate || "",
      rateUnit: productData?.rateUnit || "",
      containerSize: productDetail?.containerSize || "",
      containerType: productDetail?.containerType || "",
      containerUnit: productDetail?.containerUnit || "Ltr",
    });

    setProduct(getProductOptionById(productDetail?.productId));
  }, [productDetail, open.edit]);



  return (
    <CustomModal
      open={open.add || open.edit}
      title={open.add ? "Add Product" : "Edit Product"}
      actionButtonTitle={open.add ? "Save" : "Edit"}
      onClose={handleModalClose}
      onSubmit={handleSubmit}
      loading={false}
      bodyClass="modal-body p-0 border_structure"
    >
      <div className="common-modal-form">
        <div className="row gy-4">
          <ReactSelector
            options={productOptions}
            label="Product Name"
            placeholder="Select Product"
            value={product}
            isLoading={isProductLoading}
            onChange={(value) => {
              handleSelectProduct(value);
            }}
            name={"productName"}
            error={errors?.productName}
            touched={touched?.productName}
          />

          <div className="col-lg-6">
            <div className="common-modal-field">
              <label>Rate</label>
              <div className="rate-input-field position-relative">
                <input
                  type="text"
                  name="rate"
                  className="form-control"
                  placeholder="Enter the rate"
                  value={values.rate}
                  error={errors.rate}
                  touched={touched.rate}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                {productData && (
                  <div className="rate-input-title-blk">
                    <p className="mb-0">
                      {values.rateUnit}/{values.containerSize}
                      {values.containerUnit} {values.containerType}
                    </p>
                  </div>
                )}
              </div>
              {touched.rate && errors.rate && (
                <p style={{ color: "red", marginBottom: 0 }}>{errors.rate}</p>
              )}
            </div>
          </div>
          <div className="col-lg-12">
            <CustomTextArea
              rows="15"
              label="Notes"
              type="text"
              name="notes"
              placeholder="Enter your notes"
              value={values.notes}
              error={errors.notes}
              touched={touched.notes}
              onChange={handleChange}
              onBlur={handleBlur}
            />
          </div>
        </div>
      </div>
    </CustomModal>
  );
};

export default CropAddProductModel;
